import React, { ReactNode, useState } from 'react';
import styled from 'styled-components';

import { useInitialMarginFractionOverrideQueries } from '#/api/queries/initialMarginFractionOverrideQueries';
import { useOrdersQuery } from '#/api/queries/orderQueries';
import { useWalletWithPositionsQuery } from '#/api/queries/walletPositionsQueries';
import Button from '#/components/basic/Button/Button';
import { useSelector } from '#/reduxState/store';

import { useCloseAllPositions, useClosePosition } from './closePositions';
import PositionsTable from './PositionsTable';
import TPSLModal from './takeProfitStopLoss/TPSLModal';

const TopWrap = styled.div`
  height: 56px;
  display: flex;
  align-items: center;
`;

const CloseWrap = styled.div`
  text-align: right;
  padding: 0 0 16px 0;
`;

function PositionsTableWrap({
  marketFilter,
  mobileLeftTopBlock,
}: {
  marketFilter?: string;
  mobileLeftTopBlock?: ReactNode;
}) {
  const walletAddress = useSelector(state => state.wallet.walletAddress);
  const isMobile = useSelector(state => state.screen.isMobile);
  const { data: positions } = useWalletWithPositionsQuery();
  const { closeAllModalPlaceholder, showCloseAllConfirmation } =
    useCloseAllPositions(marketFilter);

  const { data: IMFOverridesData } = useInitialMarginFractionOverrideQueries({
    walletAddress,
    isVault: false,
  });

  const { data: walletWithPositions } = useWalletWithPositionsQuery();

  // Data needed to determine position TP/SL
  const { data: allOrders } = useOrdersQuery();

  const { closeModalPlaceholder, showClosePositionModal } = useClosePosition();

  const [editTpSl, setEditTpSl] = useState<string | undefined>(undefined);

  return (
    <>
      {isMobile && mobileLeftTopBlock && (
        <TopWrap>{mobileLeftTopBlock}</TopWrap>
      )}

      {closeAllModalPlaceholder}
      {closeModalPlaceholder}
      {editTpSl && (
        <TPSLModal onClose={() => setEditTpSl(undefined)} market={editTpSl} />
      )}

      <PositionsTable
        marketFilter={marketFilter}
        positions={walletWithPositions?.positions}
        IMFOverridesData={IMFOverridesData}
        closeActions={{
          showCloseAllConfirmation,
          showClosePositionModal,
        }}
        tpSlActionsData={{
          allOrders,
          setEditTpSl,
        }}
      />

      {isMobile && !marketFilter && (
        <>
          <CloseWrap>
            <Button
              bordered
              onClick={showCloseAllConfirmation}
              color="red"
              disabled={!walletAddress || !positions?.positions?.length}
            >
              Close All
            </Button>
          </CloseWrap>
        </>
      )}
    </>
  );
}

export default PositionsTableWrap;
